import React, { useContext, useState } from 'react';
import RecordingContext from './RecordingContext';
import RecordingModal from './RecordingModal';
import RecordingBar from './RecordingBar';
import NoteTypeSelector from './NoteTypeSelector';
import { getCurrentUser } from '../../utils/userStorage';

export default function RecordingManager() {
  const ctx = useContext(RecordingContext);
  const currentUser = getCurrentUser(); // Check if currentUser exists

  // State for NoteTypeSelector
  const [showNoteTypeSelector, setShowNoteTypeSelector] = useState(false);
  const [noteTypeSelectorSessionUuid, setNoteTypeSelectorSessionUuid] = useState(null);
  const [noteTypeSelectorPatient, setNoteTypeSelectorPatient] = useState(null);

  const handleShowNoteTypeSelector = ({ sessionUuid, patient }) => {
    setNoteTypeSelectorSessionUuid(sessionUuid);
    setNoteTypeSelectorPatient(patient);
    setShowNoteTypeSelector(true);
  };

  const handleCloseNoteTypeSelector = () => {
    setShowNoteTypeSelector(false);
    setNoteTypeSelectorSessionUuid(null);
    setNoteTypeSelectorPatient(null);
  };

  return (
    <div className="recording-ui-animator">
      {ctx.showRecordingModal && (
        <div className="recording-ui--modal">
          <RecordingModal
            open={ctx.showRecordingModal}
            patient={ctx.patient}
            paused={ctx.paused}
            fromPatientDetails={ctx.fromPatientDetails}
            elapsedTime={ctx.elapsedTime}
            onShowNoteTypeSelector={handleShowNoteTypeSelector}
          />
        </div>
      )}
      {ctx.showRecordingBar && currentUser && (
        <div className="recording-ui--bar">
          <RecordingBar
            elapsedTime={ctx.elapsedTime}
            patient={ctx.patient}
            isRecording={ctx.isRecording}
            problemType={ctx.problemType}
          />
        </div>
      )}
      <NoteTypeSelector
        sessionUuid={noteTypeSelectorSessionUuid}
        visible={showNoteTypeSelector}
        onClose={handleCloseNoteTypeSelector}
        patient={noteTypeSelectorPatient}
      />
    </div>
  );
} 